"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
const fs_1 = require("fs");
class FileDataLoader {
    constructor(file) {
        this.file = file;
    }
    load(start, size) {
        return __awaiter(this, void 0, void 0, function* () {
            return (yield new Response(this.file.slice(start, size && start + size))).arrayBuffer();
        });
    }
    loadStream(start, size) {
        return __awaiter(this, void 0, void 0, function* () {
            return fs_1.createReadStream(this.file.name, { start, end: size && start + size });
        });
    }
}
exports.FileDataLoader = FileDataLoader;
//# sourceMappingURL=FileDataLoader.js.map